export enum RecurrenceType {
  No = "No",
  Daily = "Daily",
  DailyWorkdays = "DailyWorkdays",
  DailyWeekend = "DailyWeekend",
  Weekly = "Weekly",
  BiWeekly = "BiWeekly",
  EveryThirdWeek = "EveryThirdWeek",
  EveryFourthWeek = "EveryFourthWeek",
  MonthlyDayNumber = "MonthlyDayNumber",
  MonthlyFirstDay = "MonthlyFirstDay"
}
